import { useLocation, useNavigate, useRoutes } from "react-router-dom"; //获取路由对象
import routes, { flatRouterFunction } from "../../router"; //引入路由映射表

export default function () {
	const navigate = useNavigate();
	const location = useLocation();
	const pathname = location.pathname; //取到当前路由

	//判断当前路由是否在路由映射表中
	let targetRouter = "";
	const verificationRoute = flatRouterFunction().map((item) => item.path);

	targetRouter = verificationRoute.find((item) => item.replace(/\s*/g, "") === pathname);

	//判断是否在配置文件中
	// if (!targetRouter) {
	// 	return navigate("/error", {
	// 		state: {
	// 			status: 404
	// 		}
	// 	});
	// }


	/* 分区渲染路由 */
	const token = sessionStorage.getItem("token");
	if (!token) {
		const routerAuth = routes.filter((item) => item.path !== "/");
		return useRoutes(routerAuth);
	} else if (targetRouter) {
		return useRoutes(routes);
	}  else {
		return useRoutes(routes);
	}
}
